import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import Checkbox from "@mui/material/Checkbox";
import Button from "../Button/Button";
import Fi from "../Field/Fi";
import { TextField, FormGroup } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import ReactCountryFlag from "react-country-flag";

export default function ContactSellerModal({ open, setOpen }) {
  const handleClose = () => setOpen(false);
  const [isFocused, setIsFocused] = React.useState(false);
  const [include, setInclude] = React.useState(false);
  const [also, setAlso] = React.useState(false);

  const [msg, setMsg] = React.useState("");
  const handleClear = () => {
    setInclude(false);
    setAlso(false);
    setMsg("");
  };
  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "600px",
            height: "450px",
            bgcolor: "#FFFFFF",
            boxShadow:
              "0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 5px 5px rgba(0, 0, 0, 0.2)",
            outline: "none",
            borderRadius: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              padding: "24px",
            }}
          >
            <CloseIcon
              onClick={handleClose}
              sx={{
                color: "text.primary",
                marginLeft: "2px",

                "&:hover": {
                  cursor: "pointer",
                },
              }}
            />
            <Typography
              variant="subtitle1"
              fontFamily="Inter"
              fontSize="16px"
              fontWeight="600"
              lineHeight="24px"
              color="black"
              sx={{
                margin: "auto",
              }}
            >
              Send your message to the seller
            </Typography>
          </Box>
          <Box
            sx={{
              width: "100%",
              height: "1px",
              backgroundColor: "#D6D6D6",
            }}
          ></Box>
          <Box
            sx={{
              height: "280px",
              padding: "24px",
              overflowY: "scroll",
              "::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            <Heading text="Contact seller" />
            <Box sx={{ height: "24px" }}></Box>
            <TextField
              multiline
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              value={msg}
              onChange={(e) => setMsg(e.target.value)}
              label={
                !isFocused &&
                msg.length == 0 && (
                  <Typography
                    variant="body1"
                    fontFamily="Inter"
                    fontSize="16px"
                    fontWeight="400"
                    lineHeight="24px"
                    color="#616161"
                  >
                    Message
                  </Typography>
                )
              }
              sx={{
                width: "100%",
                "& .MuiOutlinedInput-root": {
                  padding: "0px",
                },
                "& .MuiOutlinedInput-input": {
                  minHeight: "110px",
                  color: "black",
                  padding: "11px 13px",
                },
              }}
            />
            <Box sx={{ marginTop: "26px" }}>
              <FormGroup
                sx={{ display: "flex", flexFlow: "column", rowGap: "8px" }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={include}
                      onChange={(e) => setInclude(e.target.checked)}
                      sx={{
                        padding: "0px",
                        width: "16px",
                        height: "16px",
                        marginRight: "8px",
                        color: "primary.main",
                        "&.Mui-checked": {
                          color: "primary.main",
                        },
                      }}
                    />
                  }
                  sx={{
                    margin: "0px",
                    "& .MuiTypography-root": {
                      fontSize: "14px",
                      lineHeight: "20px",
                      color: "#616161",
                      fontStyle: "normal",
                    },
                  }}
                  label="Include me on exclusive offers, giveaways, and machineryplanet.io news."
                />
              </FormGroup>
            </Box>
          </Box>
          <Box
            sx={{
              width: "100%",
              height: "1px",
              backgroundColor: "#D6D6D6",
            }}
          ></Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "24px",
              width: "100%",
            }}
          >
            <Typography
              fontFamily="Inter"
              fontSize="16px"
              fontWeight="600"
              lineHeight="24px"
              color="text.primary"
              sx={{
                textDecoration: "underline",
                "&:hover": {
                  cursor: "pointer",
                },
              }}
              onClick={handleClear}
            >
              Clear All
            </Typography>
            <Button
              variant="contained"
              size="lg"
              txColor="text.primary"
              bgColor="#F9D548"
              sx={{ height: "48px", width: "205px", boxShadow: "none" }}
              onClick={() => {
                handleClose();
              }}
              hoverBg="#F3C04F"
            >
              Submit Now
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

function Heading({ text }) {
  return (
    <Typography
      variant="subtitle1"
      fontSize="22px"
      fontWeight="600"
      lineHeight="26px"
      color="text.primary"
    >
      {text}
    </Typography>
  );
}
